import { useQuery } from "react-query";
import { PagedRequestType } from "../../types/PagedResults";
import { getCategories } from "../../services/library/category";
import { key_categories } from "../../utils/constants";

export const useGetCategoriesQuery = (data: PagedRequestType, options: any= null) =>
  useQuery(
    [key_categories, JSON.stringify(data)],
    () => getCategories(data),
    options?{...options}:{}
  );
